export default {
    client_id: "9cd24e6b-99a2-495e-be20-01556eb2bc33",
    graphScopesOptions: [
      {
        key: "user.read",
        value: "user.read",
        text: "user.read"
      }
    ]
}